// extracted by mini-css-extract-plugin
export var printerCard = "_bp-1";
export var printerCardConfigured = "_bp-2";
export var printerCardError = "_bp-3";
export var printerCardsContainer = "_bp-0";
export var printerIcon = "_bp-8";
export var printerIconConfigured = "_bp-5";
export var printerIconContainer = "_bp-4";
export var printerIconError = "_bp-6";
export var printerIconUnconfigured = "_bp-7";
export var workstationsTableCard = "_bp-9";